import debounce from 'lodash.debounce';
import { CLASSES } from '../_consts';

export default function toTop() {

  const backToTopElement = document.querySelector('.js-to-top');
  const { isVisible } = CLASSES;

  if (!backToTopElement) return;

  function toTopVisibility() {
    const scrolledToShow = window.pageYOffset > 50;
    if (scrolledToShow) {
      backToTopElement.classList.add(isVisible);
    } else {
      backToTopElement.classList.remove(isVisible);
    }
  }

  toTopVisibility();
  backToTopElement.addEventListener('click', () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  });

  const debouncedScroll = debounce(toTopVisibility, 50);
  window.addEventListener('scroll', () => {
    debouncedScroll();
  });
}
